import { DelayWaiter } from "./DelayWaiter";
import { PollingTaskWithResult } from "./PollingTasks";

export async function waitPollingTask<TResult>(
    pollingFunc: () => Promise<PollingTaskWithResult<TResult>>,
    abortSignal?: AbortSignal,
    delaysToWait?: number[],
    delaysCountLimits?: number[]
): Promise<TResult> {
    let task = await pollingFunc();
    const delayWaiter = new DelayWaiter(
        delaysToWait ?? DelayWaiter.DefaultDelays,
        delaysCountLimits ?? DelayWaiter.DefaultCountLimits
    );

    while (task.status === "InProgress") {
        if (abortSignal?.aborted) {
            throw new Error(`Задача taskId: ${task.id} отменена`);
        }

        await delayWaiter.delay();
        task = await pollingFunc();
    }

    if (task.status === "Success") {
        if (task.result === undefined) {
            throw new Error(`Задача taskId: ${task.id} завершилась без результата`);
        }
        return task.result;
    }
    if (task.status === "Error") {
        let errorMessage = `Ошибка с кодом ${task.errorInfo?.httpStatusCode}. TaskId: ${task.id}`;

        if (task.errorInfo?.userMessage) {
            errorMessage = task.errorInfo?.userMessage;
        }

        throw new Error(errorMessage);
    }
    throw new Error(`Задача taskId: ${task.id} отменена`);
}
